@if (safeUrl) {
  <mat-dialog-content class="h-100">
    @if (isImage) {
      <div #zoomContainer class="zoom-container">
        <img [src]="safeUrl" [style.--zoom]="zoom()" draggable="false" />
      </div>
      <div class="button-container">
        <button matMiniFab (click)="zoomIn()">
          <mat-icon>add</mat-icon>
        </button>
        <button matMiniFab (click)="zoomOut()">
          <mat-icon>remove</mat-icon>
        </button>
      </div>
    } @else {
      <iframe [src]="safeUrl"></iframe>
    }
  </mat-dialog-content>
}
<mat-dialog-actions>
  <button matButton="text" mat-dialog-close>Close</button>
</mat-dialog-actions>
